//
//
//
//

export default {
  name: 'Tabs',
  props: ["query", "setQuery", "executeSearch",],
  data() {
    return {
      tabs: null
    }
  },
  computed: {
    products(){
      this.tabs = this.options.products.split(';');
      return this.options.products.split(';');
    },
    
  },
  methods:{
    isActive(product){
     if(product === this.options.product){
        return 'is-active';
      } 
    }, 
    activeSearch(event, product){
      const tabs = document.querySelectorAll('.search-tabs__search');
      if(!event.currentTarget.classList.contains('is-active')){
        tabs.forEach(tab=>{
          tab.classList.remove('is-active');
        });
        document.querySelector(`.search-tabs__search--${product}`).classList.add('is-active');
      }
    }
  }
}
